export default __webpack_public_path__ + "static/media/user-video.18ea2704.svg";